<script>
  import { createEventDispatcher } from "svelte";

  import Dialog, { Title, Content, Actions } from "@smui/dialog";
  import Button, { Icon, Label } from "@smui/button";
  import MenuItem from "./MenuItem.svelte";

  export let vendorId;
  export let groupOptions;
  export let flagOptions;

  let title = "Menu Item";

  let defaults = {
    actions: ["cancel", "save"],
    data: { status: "active", vendor_id: vendorId, flags: []}
  };

  let dialog;
  let data = null;
  let errors = {};
  let actions = [];
  const dispatch = createEventDispatcher();

  export function open(options) {
    data = { ...defaults.data };
    actions = defaults.actions;

    if (options) {
      data = options.data ? options.data : { ...defaults.data };
      errors = options.errors ? options.errors : {};
      actions = options.actions ? options.actions : defaults.actions;
    }
    console.log(`opening dialog options: ${options}, data: `, data, errors);
    dialog.open();
  }

  function pressed(action) {
    dispatch("close", { action: action, data: data });
    data = null;
    errors = {};
  }

</script>

<Dialog
  bind:this={dialog}
  aria-labelledby="dialog-title"
  aria-describedby="dialog-content"
  >
  <Title id="dialog-title">{title}</Title>
  {#if data}
    <Content id="dialog-content">
      <MenuItem bind:data errors={errors} {groupOptions} {flagOptions}/>
    </Content>
  {/if}
  <Actions>
    {#each actions as action}
      <Button on:click={() => pressed(action)}>
        <Label>{action}</Label>
      </Button>
    {/each}
  </Actions>
</Dialog>
